export type SelectOption = {
  value: string
  label: string
  /** Extra text included when filtering search */
  keywords?: string
}

/** Sort options A→Z by label. Keeps empty-value "all" option first when present. */
export function sortSelectOptions(options: SelectOption[]): SelectOption[] {
  const empty = options.filter((o) => o.value === '')
  const rest = options
    .filter((o) => o.value !== '')
    .sort((a, b) => a.label.localeCompare(b.label, 'en', { sensitivity: 'base' }))
  return [...empty, ...rest]
}
